import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity, OpbouwInkomenBox1,
  OpbouwPU,
  SpecificatiePU
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-periodieke-uitkeringen',
  templateUrl: './overzicht-periodieke-uitkeringen.component.html',
  styleUrls: ['./overzicht-periodieke-uitkeringen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class OverzichtPeriodiekeUitkeringenComponent implements OnInit {

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specPUFormGroup = this.fb.group<AangifteRapport>({});
    specPU = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specPUFormGroup = this.fb.group<AangifteRapport>(({
            specificatiePU: this.fb.group<SpecificatiePU>(({
                opbouw: this.fb.group<OpbouwPU>(({
                    berekendeUitkomst: null as unknown as number,
                    ontvangenAlimentatie: null as unknown as number,
                    kostenAlimentatie: null as unknown as number,
                    saldoAlimentatie: null as unknown as number,
                    ontvangenPeriodiekeUitkeringen: null as unknown as number,
                    kostenPeriodiekeUitkeringen: null as unknown as number,
                    saldoPeriodiekeUitkeringen: null as unknown as number,
                } as OpbouwPU))
            } as SpecificatiePU))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    periodiekeUitkeringen: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specPUFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.calculateTelling();
                    this.updateForm()
                    this.disableFormGroup(this.specPUFormGroup);
                    this.disableFormGroup(this.berekeningBox1FormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specPU = this.partnerRapport;
            this.specPUFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
        } else {
            this.specPU = this.aangifteRapport;
            this.specPUFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening)
        }
    }

    calculateTelling(): void {
        const ontvangenAlimentatie = this.aangifteRapport.specificatiePU?.opbouw?.ontvangenAlimentatie?.valueOf() || 0;
        const kostenAlimentatie = this.aangifteRapport.specificatiePU?.opbouw?.kostenAlimentatie?.valueOf() || 0;
        const saldoAlimentatie = ontvangenAlimentatie - kostenAlimentatie
        this.specPUFormGroup.get(['specificatiePU', 'opbouw', 'saldoAlimentatie'])?.patchValue(saldoAlimentatie);

        const ontvangenPU = this.aangifteRapport.specificatiePU?.opbouw?.ontvangenPeriodiekeUitkeringen?.valueOf() || 0;
        const betaaldePU = this.aangifteRapport.specificatiePU?.opbouw?.kostenPeriodiekeUitkeringen?.valueOf() || 0;
        const saldoPU = ontvangenPU - betaaldePU
        this.specPUFormGroup.get(['specificatiePU', 'opbouw', 'saldoPeriodiekeUitkeringen'])?.patchValue(saldoPU);
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

